import { createReducer } from '@reduxjs/toolkit';
import { LoadingStatuses } from '@packages/shared/core/common/entities';
import { fetchLocationPending, fetchLocationSucceed, fetchLocationFailed } from './actions';
import { LocationState } from './state';

export const locationInitialState: LocationState = {
  location: {},
  loadingsStatus: LoadingStatuses.IDLE,
};

export const locationReducer = createReducer(locationInitialState, (builder) => {
  builder
    .addCase(fetchLocationPending, (state) => {
      state.loadingsStatus = LoadingStatuses.PENDING;
    })
    .addCase(fetchLocationSucceed, (state, { payload }) => {
      state.location = payload;
      state.loadingsStatus = LoadingStatuses.FULFILLED;
    })
    .addCase(fetchLocationFailed, (state) => {
      state.loadingsStatus = LoadingStatuses.FAILED;
    });
});
